import styles from './LoadingScreen.module.scss';

export function LoadingScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.logoWrap}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="46"
          viewBox="0 0 168 148"
          fill="none"
        >
          <path
            d="M101.158 0C84.9501 0 69.972 5.38183 60.0239 14.2394L60.1357 1.90607H45.7165H29.6208L17.6607 57.0697C14.7545 72.4303 25.1497 74.2243 30.515 74.7849L30.2914 75.1212C24.9261 75.7939 13.4131 78.9333 10.7305 91.8273L4.69456 122.885C4.35923 124.791 0 148 0 148H16.8782H18.3313C28.2794 148 36.8862 140.936 38.7864 131.182L45.1576 99.7879C51.8642 106.739 63.0419 110.327 75.4491 110.327C109.317 110.327 136.032 87.9031 142.738 54.7152C149.445 21.8637 133.014 0 101.158 0ZM105.629 55.6121C102.723 70.0758 90.3154 80.3909 75.002 80.3909C59.3533 80.3909 51.0818 70.6364 54.0998 55.6121L54.4351 53.8182C57.2295 40.3636 68.966 30.0485 84.8383 30.0485C100.152 30.0485 108.758 40.3636 105.629 55.6121Z"
            fill="#144dff"
          />
          <path
            d="M147.992 3.36364V2.01819H155.928V3.36364H152.687V12.3333H151.122V3.36364H147.992Z"
            fill="#144dff"
          />
          <path
            d="M157.604 2.01819H159.505L162.746 9.9788H162.858L166.099 2.01819H168V12.3333H166.547V4.93335H166.435L163.417 12.3333H162.187L159.169 4.93335H159.058V12.3333H157.604V2.01819Z"
            fill="#144dff"
          />
        </svg>
      </div>
      <div className={styles.dots}>
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
